<app-toast #toast />
@if (emptyRouter) {
<div class="empty-router">
  <router-outlet />
</div>
@if (!hideFooter) {
<app-hero-footer />
} } @else {
<div class="main-wrapper wrapper" [ngClass]="{ 'is-mobile': isMobile }">
  @if (httpLoadingInProgress | async) {
  <div class="progess-wrapper">
    <mat-progress-bar mode="query"></mat-progress-bar>
  </div>
  } @if(loaded){ @if (sideBarOpen) {
  <div class="shadow-bg" (click)="onToggleSidebar(false)"></div>
  }
  <app-sidebar
    [open]="sideBarOpen"
    [userName]="userName"
    [userMail]="userMail"
    [referral_url]="referral_url"
    [onboarded]="onboarded"
    [showDirectDebitInfo]="showDirectDebitInfo"
    [onlyProperties]="(hasPropertiesSubscription || !hasValidSubscription)"
    (sidebarClosed)="onToggleSidebar(false)"
    class="sidebar"
    [ngClass]="sideBarOpen ? 'open' : 'close'" />

  <div class="bueno-content">
    <app-header [navMenuOpen]="sideBarOpen" (headerClicked)="onToggleSidebar(true)" [disableOptions]="!onboarded" />
    @if (httpLoadingInProgress | async) {
    <div class="progess-wrapper">
      <mat-progress-bar mode="query"></mat-progress-bar>
    </div>
    } @if (showNativeAppAdd) {
    <div
      [ngClass]="
          useWhiteBackground ? 'has-background-white no-side-padding' : ''
        ">
      <div
        class="notification is-link is-light mx-4 mt-4 p-0"
        style="background-color: #292a4930; margin-bottom: 0px !important">
        <button class="delete" aria-label="delete" (click)="this.closeAppAdd()"></button>
        <div class="p-4 has-text-centered">
          <p class="font-title" style="margin-bottom: 0px !important">{{ "NATIVE_APP_ADD.TITLE" | translate }}</p>
          <p class="font-subtitle m-2">{{ "NATIVE_APP_ADD.SUBTITLE" | translate }}</p>
          <button class="button is-primary" (click)="this.redirectToAppStore()">
            <p class="font-subtitle">{{ "NATIVE_APP_ADD.INSTALL" | translate }}</p>
          </button>
        </div>
      </div>
    </div>
    } @if(!isOnboardingRoute){
    <div class="page-content">
      <router-outlet></router-outlet>
    </div>
    }
  </div>
  }
</div>
}
<div class="modal is-active error-modal" [class.is-active]="httpLoadingInProgress | async">
  <div class="modal-background" style="position: fixed"></div>
  <div class="modal-content has-background-white has-radius-10 loading-modal">
    <div class="box shadow m-0" style="text-align: center">
      <p class="font-subtitle">{{ (downloadInProgress ? "DOWNLOADING" : "LOADINGMODAL") | translate }}</p>
      <br />
      <fa-icon class="loading_icon" [icon]="faSpinner" [animation]="'spin'" [size]="'3x'"></fa-icon>
    </div>
  </div>
</div>
<div class="modal error-modal app-error-modal" [class.is-active]="showError">
  <div class="modal-background app-error-modal__backdrop"></div>
  <div
    class="modal-content app-error-modal__panel"
    role="alertdialog"
    aria-modal="true"
    aria-labelledby="app-error-modal-title">
    <h2 id="app-error-modal-title" class="app-error-modal__title">
      {{ "ERROR_CODES.SOMETHING_WENT_WRONG_TITLE" | translate }}
    </h2>
    <p class="app-error-modal__intro">{{ "ERROR_CODES.ERROR_MODAL_INFO" | translate }}</p>
    <div class="app-error-modal__messages">
      @if (blockedAccountError) {
      <p class="app-error-modal__message">
        {{ "CARDS_MODULE.DETAILS" | translate }}: {{ "ERROR_CODES.ACCOUNT_BLOCKED" | translate }}
      </p>
      } @else { @for (errorDetail of errorDetails; track errorDetail) {
      <p class="app-error-modal__message">
        {{ "CARDS_MODULE.DETAILS" | translate }}: @if (showErrorTranslation) { {{ "ERROR_CODES." + errorDetail.code |
        translate }} } @else if (showErrorDescription) { {{ errorDetail.description ? errorDetail.description :
        errorDetail.code }} } @else { {{ "ERROR_CODES.ERROR" | translate }} }
      </p>
      } }
    </div>
    @if (!blockedAccountError) {
    <p class="app-error-modal__support">{{ "ERROR_CODES.ERROR_MODAL_SUPPORT" | translate }}</p>
    }
    <div class="app-error-modal__actions" [class.app-error-modal__actions--stacked]="enableReload">
      @if (blockedAccountError) {
      <app-button-primary variant="primary-btn" size="medium-btn" (onClick)="openSupport()">
        {{ "ERROR_CODES.CONTACT_SUPPORT" | translate }}
      </app-button-primary>
      } @else { @if (enableReload) {
      <app-button-primary variant="primary-btn" size="medium-btn" (onClick)="this.reload()">
        {{ "ERROR_CODES.RELOAD" | translate }}
      </app-button-primary>
      }
      <app-button-primary
        [variant]="enableReload ? 'primary-outline-btn' : 'primary-btn'"
        size="medium-btn"
        (onClick)="showError = false">
        {{ "ERROR_CODES.CLOSE" | translate }}
      </app-button-primary>
      }
    </div>
  </div>
</div>
@if (maintenance) {
<div class="modal is-active" style="position: fixed">
  <div class="modal-background"></div>
  <div
    class="modal-content has-background-white has-radius-10 loading-modal has-text-centered"
    [ngClass]="isMobile ? 'p-3' : 'p-6'"
    [ngStyle]="{
      'max-height': isMobile ? '95%' : '',
      width: isMobile ? '95%' : ''
    }">
    <div>
      <p class="font-title font-subtitle">{{ "MAINTENANCE.TITLE" | translate }}</p>
      <p class="font-subtitle font-standard">{{ "MAINTENANCE.MESSAGE" | translate }}</p>
      @if (this.enableReload) {
      <button class="button is-primary is-medium is-medium mt-5" (click)="this.reload()">
        {{ "ERROR_CODES.RELOAD" | translate }}
      </button>
      }
    </div>
  </div>
</div>
}
<app-feedback-popup />
<div class="modal" [class.is-active]="showLogoutQuestion">
  <div class="modal-background" style="position: fixed"></div>
  <div class="modal-content p-2" style="position: fixed">
    <article class="message">
      <div class="message-content p-4 has-text-centered">
        <p class="font-subtitle m-2">{{ "ERROR_CODES.CLOSESESSION" | translate }}</p>
        <button class="button m-2 is-primary" (click)="this.startLogoutTimer()">{{ "CONTINUE" | translate }}</button>
        <button class="button m-2 is-danger" (click)="this.logout()">{{ "ERROR_CODES.CLOSE" | translate }}</button>
      </div>
    </article>
  </div>
</div>
@if (authenticated && subscriptionDisabled) {
<div class="modal is-active" style="position: fixed">
  <div class="modal-background"></div>
  <div
    class="modal-content onboarding-modal"
    [ngClass]="isMobile ? 'p-3' : 'p-6'"
    [ngStyle]="{
      'max-height': isMobile ? '95%' : '',
      width: isMobile ? '95%' : ''
    }">
    <div class="columns is-mobile">
      <div class="column">
        <app-language-selector [language]="language" (languageChange)="setLanguage($event)" />
      </div>
      <div class="column">
        @if (authenticated) {
        <a class="navbar-item" style="text-align: end; padding: 0px; display: block">
          <p class="has-text-danger">
            <fa-stack (click)="logout()">
              <fa-icon [icon]="faCircle" stackItemSize="2x"></fa-icon>
              <fa-icon [icon]="faSignOut" [inverse]="true" stackItemSize="1x"></fa-icon>
            </fa-stack>
          </p>
        </a>
        }
      </div>
    </div>
    <div>
      <p class="font-title font-subtitle">{{ "EXPIRED_SUBSCRIPTION.SUBSCRIPTION_EXPIRED" | translate }}</p>
      <p class="font-subtitle font-standard">{{ "EXPIRED_SUBSCRIPTION.ENDING_SUBTITLE" | translate }}</p>
      <app-subscription-plans [reference]="this" [resubscription]="true"></app-subscription-plans>
    </div>
  </div>
</div>
} @if(authenticated && isOnboardingRoute){
<div class="modal is-active" style="position: fixed">
  <div class="modal-background"></div>
  <div
    class="modal-content onboarding-modal"
    [ngClass]="isMobile ? 'p-3' : 'p-4'"
    [ngStyle]="{
      'max-height': isMobile ? '95%' : '',
      width: isMobile ? '95%' : ''
    }">
    <div class="columns is-mobile">
      <div class="column">
        <app-language-selector [language]="language" (languageChange)="setLanguage($event)" />
      </div>
      <div class="column">
        @if (authenticated) {
        <a class="navbar-item" style="text-align: end; padding: 0px; display: block">
          <p class="has-text-danger">
            <fa-stack (click)="logout()">
              <fa-icon [icon]="faCircle" stackItemSize="2x"></fa-icon>
              <fa-icon [icon]="faSignOut" [inverse]="true" stackItemSize="1x"></fa-icon>
            </fa-stack>
          </p>
        </a>
        }
      </div>
    </div>
    <div>
      <router-outlet />
    </div>
  </div>
</div>
}
